export default {module:'Card/List',view:'Element/Message/List',options:{key:'list',md:12}}